<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Vehículo LS</h3>
    <small>Gestión de unidades, empleados y permisos legales</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        
        <p class="lead bb text-primary">Información de Asignación</p>
        <div class="row">
          <div class="col-md-6">
            <label class="text-bold">Unidad / CEVE</label>
            <ng-autocomplete 
              placeholder="Buscar unidad..." 
              [data]="units" 
              [searchKeyword]="searchUnitField" 
              (selected)='changeUnit($event)' 
              [itemTemplate]="unitTmpl" 
              [(ngModel)]="selectedUnit" 
              name="selectedUnit" 
              [disabled]="!isNew">
            </ng-autocomplete>
          </div>

          <div class="col-md-6">
            <label class="text-bold">Empleado / Operador</label>
            <ng-autocomplete 
              placeholder="Buscar empleado..." 
              [data]="employees" 
              [searchKeyword]="searchEmployeeField" 
              (selected)='changeEmployee($event)' 
              [itemTemplate]="empTmpl" 
              [(ngModel)]="selectedEmployee" 
              name="selectedEmployee" 
              [disabled]="!isNew">
            </ng-autocomplete>
          </div>
        </div>

        <p class="lead bb text-primary mt-4">Detalles Técnicos</p>
        <div class="row">
          <div class="col-md-3">
            <aph-custom-text 
              label="Placas" 
              [(ngModel)]="carrier.LicensePlate" 
              name="LicensePlate" 
              [required]="true" 
              [maxLength]="20"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Año Modelo" 
              type="numeric" 
              [(ngModel)]="carrier.ModelYear" 
              name="ModelYear" 
              [required]="true"
              [maxLength]="4"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Configuración (C2/VL)" 
              [(ngModel)]="carrier.VehicleConfiguration" 
              name="VehicleConfiguration" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Sub Tipo" 
              [(ngModel)]="carrier.SubTipoTrailer" 
              name="SubTipoTrailer" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <p class="lead bb text-primary mt-4">Permisos y Seguros</p>
        <div class="row">
          <div class="col-md-3">
            <aph-custom-text 
              label="Permiso SCT" 
              [(ngModel)]="carrier.SCTPermit" 
              name="SCTPermit" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Número SCT" 
              type="numeric" 
              [(ngModel)]="carrier.NumberSCTPermit" 
              name="NumberSCTPermit" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Aseguradora" 
              [(ngModel)]="carrier.Insurance" 
              name="Insurance" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-3">
            <aph-custom-text 
              label="Póliza de Seguro" 
              [(ngModel)]="carrier.InsurancePolicy" 
              name="InsurancePolicy" 
              [required]="true"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <hr class="mt-4">

        <div class="row">
          <div class="col-12 d-flex">
            <aph-custom-buttons preset="save" label="Guardar" type="submit" [disabled]="!Form.valid" class="mr-2"></aph-custom-buttons>
            <aph-custom-buttons preset="exit" label="Salir" (btnClick)="btnCancelOnClick()"></aph-custom-buttons>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>

<ng-template #unitTmpl let-item><a [innerHTML]="item.UnitDescription"></a></ng-template>
<ng-template #empTmpl let-item><a [innerHTML]="item.EmployeeName"></a></ng-template>